<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="addCategory.show"
            hide-footer
            hide-header-close
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">{{ ( isEdit() ? 'แก้ไขหมวดหมู่' : 'เพิ่มหมวดหมู่' ) }}</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <form @submit.prevent="validateCategory()">
                    <div class="row">
                        <div class="col-lg-12">
                            <UploadImage :imageFile="addCategory.image"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ชื่อหมวดหมู่
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ชื่อหมวดหมู่"
                                    v-model="addCategory.name"
                                    :class="{ 'is-invalid': submitCategory && $v.addCategory.name.$error }"
                                />
                                <div
                                    v-if="submitCategory && $v.addCategory.name.required == false"
                                    class="invalid-feedback d-block">กรุณากรอกชื่อหมวดหมู่
                                </div> 
                            </div>
                        </div>
                        <div class="col-lg-12 text-center">
                            <b-button variant="outline-primary" class="px-4" @click="closeModal()">
                                ยกเลิก
                            </b-button>
                            <b-button type="submit" variant="primary" class="px-4">
                                <i class="fas fa-circle-notch fa-spin" v-if="addCategory.isLoad"></i> ยืนยัน
                            </b-button>
                        </div>
                    </div>
                </form>
            </card>
        </b-modal>
    </div>
</template>

<script>
import UploadImage from '@/components/custom/service/UploadImage'
import { createCategoryService , updateCategoryDetail  } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { required } from "vuelidate/lib/validators";

export default {
    props:{
        addCategory: Object
    },
    components:{
        UploadImage
    },
    data(){
        return{
            submitCategory: false
        }
    },
    validations: {
        addCategory: {
            name: { required }
        }
    },
    methods:{
        isEdit(){
            return !!this.addCategory.categoryId
        },
        closeModal(){
            this.addCategory.show = false
            this.addCategory.isLoad = false
            this.submitCategory = false; 
            this.addCategory.name = ""
            this.addCategory.categoryId = null
            this.addCategory.image.file = null
            this.addCategory.image.preview = null
        },
        validateCategory(){
            this.submitCategory = true
            this.$v.addCategory.$touch();
            if (this.$v.addCategory.$invalid) {
                return false
            }
            this.isEdit() ? this.editCategoryService() : this.addCategoryService()
        },
        addCategoryService(){
            this.addCategory.isLoad = true
            createCategoryService( this.addCategory ).then( res => {
                showSuccessModal('เพิ่มหมวดหมู่สำเร็จ')
                this.reLoadCategory()
            }).catch( error => {
                showErrorModal(error)
                this.addCategory.isLoad = false
            });
        },
        editCategoryService(){
            this.addCategory.isLoad = true
            updateCategoryDetail( this.addCategory ).then( res => {
                this.addCategory.categoryId = null
                showSuccessModal('แก้ไขหมวดหมู่สำเร็จ')
                this.reLoadCategory()
            }).catch( error => {
                showErrorModal(error)
                this.addCategory.isLoad = false
            });
        },
        reLoadCategory(){
            this.closeModal()
            this.$emit('getApiCategoryService')
        }
    }
}
</script>